import { useState, useCallback } from "react";

export function useDialog<T = undefined>() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | undefined>(undefined);

  const open = useCallback((dialogData?: T) => {
    setIsOpen(true);
    if (dialogData !== undefined) {
      setData(dialogData);
    }
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setData(undefined);
  }, []);

  return {
    isOpen,
    open,
    close,
    /** Data associated with the dialog (undefined if not provided) */
    data,
  };
}
